// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Mandant, MandantDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateMandant(): (
  requestBody: MandantDaten
) => Promise<Mandant> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).mandanten.createMandant({ requestBody }),
    [getAPI]
  );
}
